// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--35EwX"};